import { IArea, IStateAwareArea } from 'types/map';
import {
  findParentArea,
  hasHitbox,
  isCurrentArea,
  isDestination,
  isDistrict,
  isLabelled,
  isLit,
  shouldAppearOnMap,
  shouldShowMainDestination,
  shouldShowTooltip,
  isInteractableAtThisZoomLevel,
  shouldHaveHitbox,
  isLandmark,
  shouldShowBorderFanciness,
  shouldShowGateIcon,
  shouldShowLockIcon,
  shouldZoomOnTapAtZoomLevel,
  isMappable, getHitboxForArea,
} from 'components/Map/util';

export default function asStateAwareArea(area: IArea, areas: IArea[], currentArea: IArea | undefined): IStateAwareArea {
  return {
    ...area,
    getHitboxForZoomLevel: (zoomLevel) => getHitboxForArea(area, zoomLevel),
    hasHitbox: hasHitbox(area),
    isCurrentArea: isCurrentArea(area, currentArea),
    isDestination: isDestination(area),
    isDistrict: isDistrict(area),
    isLabelled: isLabelled(area),
    isLandmark: isLandmark(area),
    isLit: isLit(area),
    isMappable: isMappable(area, areas),
    parentArea: findParentArea(area, areas),
    shouldAppearOnMap: shouldAppearOnMap(area),
    shouldBeInteractiveAtZoomLevel: (zoomLevel) => isInteractableAtThisZoomLevel(area, zoomLevel),
    shouldHaveHitboxAtZoomLevel: (zoomLevel) => shouldHaveHitbox(area, zoomLevel),
    shouldShowBorderFancinessAtZoomLevel: (zoomLevel) => shouldShowBorderFanciness(area, zoomLevel),
    shouldShowGateIcon: shouldShowGateIcon(area),
    shouldShowLockIcon: shouldShowLockIcon(area),
    shouldShowMainDestination: shouldShowMainDestination(area),
    shouldShowTooltip: shouldShowTooltip(area),
    shouldZoomOnTapAtZoomLevel: (zoomLevel) => shouldZoomOnTapAtZoomLevel(area, zoomLevel),
  }
}
